import React from "react";
import { prizeRulesocks } from "../mocks/prizeRulesMocks";
import RichTextRenderer from "../components/common/richTextRerender";
import useLanguageTranslate from "../hooks/useLanguageTranslate";
import { useSelector } from "react-redux";
import { selectPrizeRulesWhole } from "../redux/features/prizeRulesSlice";

const PrizeRules = () => {
  const translate = useLanguageTranslate()

  // const prizeRules = prizeRulesocks.data.content;
  const prizeRulesRedux = useSelector(selectPrizeRulesWhole)
  const prizeRules = prizeRulesRedux?.data?.data;
  return <div className="dynamic_page prize-rules w-[1128px]  mx-auto max-w-[100%] flex-col items-center gap-20 pt-[80px] pb-[100px] max767:p-5 ipad:px-12 ipad:py-12 laptop:px-12 laptop:py-16">
    <RichTextRenderer content={translate(prizeRules?.content, prizeRules?.content_ar)} />;
  </div>

};
export default PrizeRules;
